import React, { useEffect, useState } from 'react';
import API from '../api';

const DISMISS_KEY = 'agorax_avisos_descartados';

const leerDescartados = () => {
  try {
    return JSON.parse(localStorage.getItem(DISMISS_KEY) || '[]');
  } catch {
    return [];
  }
};

const guardarDescartados = (ids) => {
  try {
    localStorage.setItem(DISMISS_KEY, JSON.stringify(ids.slice(0, 200)));
  } catch {}
};

// Banner de avisos del super admin: al cargar el panel, consulta los avisos activos
// (globales + los de la empresa) y muestra los que el usuario aun no descarto.
export default function AvisosBanner() {
  const [avisos, setAvisos] = useState([]);

  useEffect(() => {
    API.get('/avisos')
      .then((r) => {
        if (r.data.status !== 'success') return;
        const descartados = new Set(leerDescartados());
        const visibles = (r.data.data || []).filter((a) => !descartados.has(a.id));
        setAvisos(visibles);
      })
      .catch(() => {});
  }, []);

  const descartar = (id) => {
    const descartados = new Set(leerDescartados());
    descartados.add(id);
    guardarDescartados(Array.from(descartados));
    setAvisos((prev) => prev.filter((a) => a.id !== id));
  };

  if (!avisos.length) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '12px' }}>
      {avisos.map((a) => (
        <div
          key={a.id}
          style={{
            background: '#0B1A4A',
            color: '#fff',
            borderRadius: '12px',
            padding: '12px 16px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            gap: '12px',
            boxShadow: '0 4px 16px rgba(11,26,74,0.2)',
          }}
        >
          <div>
            <div style={{ fontWeight: 700, fontSize: '14px' }}>{a.titulo}</div>
            <div style={{ fontSize: '13px', opacity: 0.85, marginTop: '4px' }}>{a.mensaje}</div>
          </div>
          <button
            onClick={() => descartar(a.id)}
            title="Descartar"
            style={{
              background: 'rgba(255,255,255,0.15)',
              border: 'none',
              cursor: 'pointer',
              color: '#fff',
              padding: '4px 10px',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: 700,
              flexShrink: 0,
            }}
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  );
}
